import { render } from "./FloatLabelDemo.vue?vue&type=template&id=477302da&scoped=true"
import script from "./FloatLabelDemo.vue?vue&type=script&lang=js"
export * from "./FloatLabelDemo.vue?vue&type=script&lang=js"

import "./FloatLabelDemo.vue?vue&type=style&index=0&id=477302da&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477302da"]])

export default __exports__